import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ViewCallingUi } from 'pages/chatbot/pages/calling/pages/view/ui/ViewCallingUi'
import { ViewCallingContext } from 'pages/chatbot/pages/calling/pages/view/context'
import { ViewCallingStore } from 'pages/chatbot/pages/calling/pages/view/store/ViewCallingStore'

export const ViewCalling = () => {
  const entities = useEntitiesContext()
  const { id } = useParams()
  const [store] = useState(() => new ViewCallingStore(entities, Number(id)))

  useEffect(store.init, [])

  return (
    <ViewCallingContext.Provider value={store}>
      <ViewCallingUi />
    </ViewCallingContext.Provider>
  )
}
